import { createAsyncThunk } from '@reduxjs/toolkit';
import { getCurrency } from '../context/context-selector.js';
export const productView = createAsyncThunk('commerce/product/view', async (payload, { extra, getState }) => {
    const { relay } = extra;
    const currency = getCurrency(getState().commerceContext);
    const relayPayload = { currency, product: payload };
    relay.emit('ec.productView', relayPayload);
});
export const productClick = createAsyncThunk('commerce/product/click', async (payload, { extra, getState }) => {
    const { relay } = extra;
    const currency = getCurrency(getState().commerceContext);
    const relayPayload = { currency, ...payload };
    relay.emit('ec.productClick', relayPayload);
});
